import React, { useState, useEffect, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";
import ChatSupportBtn from "./ChatSupportBtn";
import img from "./../assets/images/default-user.png";
import verified from "./../assets/images/verified.png";
import { logout } from "./Utility";
import check from "./../assets/images/checkmark.png";
import del_red from "./../assets/images/delete_red_icon.png";
import load_blue from "./../assets/images/load_blue.png";
import customFetch from "./apicall/api";
import "../assets/css/UPI_autopay_styles.css";

export default function UPI_autopay() {
  const history = useHistory();
  const location = useLocation();
  const [searchhhno, setSearchHHNo] = useState("");
  const [hhdata, setHHData] = useState([]);
  const [hhvpadata, setHHVPAData] = useState([]);
  const [isSpin, setIsSpin] = useState(false);
  const [isAddvpa, setIsAddvpa] = useState(false);
  const [isSetDefault, setIsSetDefault] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isInternet, setIsInternet] = useState(false);
  const [isHistory, setIsHistory] = useState(false);
  const [isaddVpaRes, setIsAddVpaRes] = useState(false);
  const [isVpaMessage, setIsVpaMessage] = useState("");
  
  // New state for Validate/Register confirmation
  const [isValidateConfirm, setIsValidateConfirm] = useState(false);
  const [isRegisterConfirm, setIsRegisterConfirm] = useState(false);

  const [VpaId, setVpaId] = useState("");
  const [hhid, setHHId] = useState("");
  const [family_member_id, setFamilyMemberId] = useState("");
  const [setdefault, setSetdefault] = useState(0);
  const [isDefault, setIsDefault] = useState(0);

  const [isValidate, setIsValidate] = useState(0);

  const [remark, setRemark] = useState("");
  const [remarkErr, setRemarkErr] = useState("");
  const [Family_member_err, setFamily_member_err] = useState("");

  const [HistoryData, setHistoryData] = useState([]);

  const [api_token, setApiToken] = useState("");
  const [hh_no, setHHNo] = useState("");
  const [effective_designation_id, setEffectiveDesignationId] = useState("");
  const [otherScreen, setOtherScreen] = useState(0);

  const [reg_vpa, setRegVpa] = useState("");
  const [canResend, setCanResend] = useState(false);
  const [time, setTime] = useState({ minutes: 0, seconds: 0 });
  const [duration] = useState(5 * 60 * 1000);

  const timerRef = useRef(null);
  const startTimeRef = useRef(null);

  // Effect to auto-trigger search when household number changes
  useEffect(() => {
    if (searchhhno && api_token && searchhhno !== "" && otherScreen === 0) {
      console.log("Auto-triggering gethhdetail with:", searchhhno);
      gethhdetail();
    }
  }, [searchhhno, api_token, otherScreen]);

  /* ===========================
       ON LOAD: Check incoming request
    ============================*/
  useEffect(() => {
    const search = location.search;
    const params = new URLSearchParams(search);

    let token = params.get("api_token");
    let hh = params.get("lead_id");
    let e_id = "";

    if (token == null || hh == null) {
      // Coming from other screen
      if (location && location.state) {
        token = location.state.api_token;
        e_id = location.state.effective_designation_id;
        var hh_number = location.state.hh_number;
      }

      console.log("Received from NACHRegisterBank - hh_number:", hh_number);
      console.log("Received from NACHRegisterBank - api_token:", token);
      console.log("Received from NACHRegisterBank - e_id:", e_id);

      setApiToken(token);
      setEffectiveDesignationId(e_id);
      setHHNo(hh_number);

      if (hh_number && token) {
        setSearchHHNo(hh_number);
      }

      localStorage.getItem("in_userid");
      setOtherScreen(0);
    } else {
      e_id = params.get("e_id");
      if (!e_id) {
        history.goBack();
      } else {
        localStorage.setItem("api_token", token);
        localStorage.setItem("branch_id", params.get("b_id"));
        localStorage.setItem("e_designation_id", params.get("e_id"));
        localStorage.setItem("in_userid", params.get("u_id"));

        setApiToken(token);
        setSearchHHNo(hh);
        setEffectiveDesignationId(params.get("e_id"));
        setOtherScreen(1);
        gethhdetail();
      }
    }
  }, []);

  /* ===========================
         TIMER FUNCTIONS
  ============================*/
  function msToTime(duration) {
    let seconds = Math.floor((duration / 1000) % 60);
    let minutes = Math.floor((duration / (1000 * 60)) % 60);
    return {
      minutes: minutes.toString().padStart(2, "0"),
      seconds: seconds.toString().padStart(2, "0"),
    };
  }

  function start() {
    if (!timerRef.current) {
      startTimeRef.current = Date.now();
      timerRef.current = setInterval(run, 10);
      setRegVpa(VpaId);
    }
  }

  function run() {
    const diff = Date.now() - startTimeRef.current;
    let remaining = duration - diff;
    if (remaining < 0) remaining = 0;
    setTime(msToTime(remaining));

    if (remaining === 0) {
      clearInterval(timerRef.current);
      timerRef.current = null;
      setCanResend(true);
      setRegVpa("");
    }
  }

  /* ===========================
            API CALLS
  ============================*/
  function gethhdetail() {
    if (!searchhhno) return;

    setIsSpin(true);

    customFetch(
      process.env.REACT_APP_URL +
        "/upi/get/autopay/household/details?household_number=" +
        searchhhno,
      { method: "GET", headers: { "api-token": api_token } }
    )
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        
        let sort_vpa = [];
        if (effective_designation_id !== "20" && effective_designation_id !== 20) {
          const filteredData = data.map((item) => ({
            ...item,
            family_deatils: item.family_deatils.map((detail) => ({
              ...detail,
              vpa_details: detail.vpa_details.filter(
                (vpa) => vpa.status !== "X"
              ),
            })),
          }));
          sort_vpa = filteredData[0] && filteredData[0].family_deatils ? filteredData[0].family_deatils : [];
        } else {
          sort_vpa = data[0] && data[0].family_deatils ? data[0].family_deatils : [];
        }

        const filteredData = sort_vpa.filter((obj) => {
          return obj.vpa_details.some(
            (vpa) => vpa.autopay_status_type_flag === "R"
          );
        });
        
        const countdefaultdata = sort_vpa.filter((obj) => {
          return obj.vpa_details.some((vpa) => vpa.default_flag === 1);
        });

        let count = filteredData.length;
        let countdefault = countdefaultdata.length;

        if (count >= 1 && countdefault === 0) {
          const filteredVpaAddresses = sort_vpa
            .map((item) => item.vpa_details)
            .flat()
            .filter((vpa) => vpa.autopay_status_type_flag === "R")
            .map((vpa) => vpa.vpa_address);

          setHHId(data[0] && data[0].household_id ? data[0].household_id : "");
          setVpaId(filteredVpaAddresses[0] || "");
          setIsDefault(1);
          setSetdefault(1);
        }

        setHHData(data[0] || []);
        setHHVPAData(sort_vpa);
      })
      .catch(() => setIsSpin(false));
  }

  function addvpa() {
    setIsSpin(true);
    customFetch(
      `${process.env.REACT_APP_URL}/upi/validate/vpa?hh_id=${hhid}&vpa=${VpaId}&family_member_id=${family_member_id}`,
      { method: "GET", headers: { "api-token": api_token } }
    )
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        setIsAddVpaRes(true);
        setIsVpaMessage(data.message);
        setIsAddvpa(false);
        setIsValidate(1);
        setIsValidateConfirm(false); // Close confirmation modal
      })
      .catch(() => setIsSpin(false));
  }

  function registerHH() {
    let valid = true;
    if (family_member_id === "" || family_member_id === null) {
      valid = false;
      setFamily_member_err("Please Select Family Member");
    }

    if (valid) {
      setIsSpin(true);

      const formdata = new FormData();
      formdata.append("household_id", hhid);
      formdata.append("vpa", VpaId);
      formdata.append("family_member_id", family_member_id);

      customFetch(process.env.REACT_APP_URL + "/upi/register/autopay", {
        method: "POST",
        headers: { "api-token": api_token },
        body: formdata,
      })
        .then((res) => res.json())
        .then((data) => {
          setIsSpin(false);
          if (data.api_code === 4) {
            localStorage.clear();
            history.push("/");
            return;
          }
          setIsAddVpaRes(true);
          setIsVpaMessage(data[0] && data[0].message ? data[0].message : "Registration successful");
          setIsAddvpa(false);
          setIsInternet(false);
          start();
        })
        .catch(() => setIsSpin(false));
    }
    setCanResend(false);
  }

  function UpdateVPAstatus(vpaAddress) {
    setIsSpin(true);
    setVpaId(vpaAddress);

    customFetch(
      process.env.REACT_APP_URL + "/upi/get/auth/request/status?vpa=" + vpaAddress,
      { method: "GET", headers: { "api-token": api_token } }
    )
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        setIsAddVpaRes(true);
        setIsVpaMessage(data[0] && data[0].message ? data[0].message : "Status updated");
        gethhdetail(); // Refresh the data after update
      })
      .catch(() => setIsSpin(false));
  }

  function deactiveVPA() {
    if (!remark) {
      setRemarkErr("Please Enter Remark");
      return;
    }

    setIsSpin(true);
    const formdata = new FormData();
    formdata.append("vpa", VpaId);
    formdata.append("remark", remark);

    customFetch(process.env.REACT_APP_URL + "/upi/deactive/subscription", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        setIsAddVpaRes(true);
        setIsVpaMessage(data[0] && data[0].message ? data[0].message : "Deactivated successfully");
        setIsDelete(false);
        gethhdetail(); // Refresh the data after deactivation
      })
      .catch(() => setIsSpin(false));
  }

  function gethistory(vpaAddress) {
    setIsSpin(true);
    setVpaId(vpaAddress);

    customFetch(
      process.env.REACT_APP_URL + "/upi/get/upi/autopay/history?vpa=" + vpaAddress,
      { method: "GET", headers: { "api-token": api_token } }
    )
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        setIsHistory(true);
        setHistoryData(data || []);
      })
      .catch(() => setIsSpin(false));
  }

  function setDefaultVPA() {
    setIsSpin(true);
    const formdata = new FormData();
    formdata.append("hh_id", hhid);
    formdata.append("vpa", VpaId);
    
    customFetch(process.env.REACT_APP_URL + "/upi/set/default/vpa", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        setIsSpin(false);
        if (data.api_code === 4) {
          localStorage.clear();
          history.push("/");
          return;
        }
        
        if (isDefault === 0) {
          setIsAddVpaRes(true);
          setIsVpaMessage(data.message || "Default VPA set successfully");
          setIsSetDefault(false);
        } else {
          if (setdefault === 1) {
            gethhdetail();
          }
        }
      })
      .catch(() => setIsSpin(false));
  }

  /* =====================================
              UI RENDER
  ======================================*/
  return (
    <>
      {isSpin && (
        <div className="preloader">
          <div className="loader"></div>
        </div>
      )}

      {/* POPUP - Validate Button Confirmation */}
      {isValidateConfirm && (
        <div className="modal fade show mymodal" style={{ zIndex: 10000 }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <h5 className="text-center mb-3">
                Are you sure you want to Validate VPA <strong>{VpaId}</strong>?
              </h5>
              <div className="row mt-3">
                <div className="vpabutton row col-md-12 text-center">
                  <div className="col-md-6">
                    <button
                      className="confirm-btn confirm-yes"
                      onClick={addvpa}
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="confirm-btn confirm-no"
                      onClick={() => setIsValidateConfirm(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - Set Default VPA */}
      {isSetDefault && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <h3 className="text-center mb-3">
                Are You Sure To Set <strong>{VpaId}</strong> as Default VPA ?
              </h3>
              <div className="row mt-3">
                <div className="vpabutton row col-md-12 text-center">
                  <div className="col-md-6">
                    <button
                      disabled={!hhid}
                      className="confirm-btn confirm-yes"
                      onClick={setDefaultVPA}
                    >
                      Yes
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="confirm-btn confirm-no"
                      onClick={() => setIsSetDefault(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - High Speed Internet Confirmation */}
      {isInternet && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <h3 className="text-center mb-3">
                Please Confirm Household Has High Speed Internet
              </h3>
              <div className="row mt-3">
                <div className="vpabutton row col-md-12 text-center">
                  <div className="col-md-6">
                    <button className="confirm-btn confirm-yes" onClick={registerHH}>
                      Yes
                    </button>
                  </div>
                  <div className="col-md-6">
                    <button
                      className="confirm-btn confirm-no"
                      onClick={() => setIsInternet(false)}
                    >
                      No
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - Response */}
      {isaddVpaRes && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                onClick={() => {
                  setIsAddVpaRes(false);
                  gethhdetail();
                }}
              >
                <span>&times;</span>
              </button>
              <p>{isVpaMessage}</p>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - History */}
      {isHistory && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content cdb-confirm-box col-sm-12">
              <button
                type="button"
                className="close text-right"
                onClick={() => setIsHistory(false)}
              >
                <span>&times;</span>
              </button>
              <div className="history-table-container">
                <table className="history-table">
                  <thead>
                    <tr>
                      <th>VPA</th>
                      <th>Mobile</th>
                      <th>Vendor</th>
                      <th>Reject Reason</th>
                      <th>Remark</th>
                    </tr>
                  </thead>
                  <tbody>
                    {HistoryData && HistoryData.map((hdata, index) => (
                      <tr key={index}>
                        <td>{hdata.upi_id}</td>
                        <td>{hdata.mobile_no}</td>
                        <td>{hdata.payment_vendor_name}</td>
                        <td>{hdata.rejection_reason}</td>
                        <td>{hdata.remark}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - Delete */}
      {isDelete && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content border11">
              <div className="modal-header modalhead">
                <h5 className="modal-title">Add Remark</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => setIsDelete(false)}
                >
                  <span>&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <textarea
                  className="form-control vpaAddress"
                  value={remark}
                  onChange={(e) => {
                    setRemark(e.target.value);
                    if (e.target.value) setRemarkErr("");
                  }}
                  placeholder="Enter remark for deactivation"
                />
                <span className="errmsg">{remarkErr}</span>
                <div className="vpabutton col-md-12 text-center mt-3">
                  <button
                    className="deactivate-btn"
                    onClick={deactiveVPA}
                  >
                    Deactivate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* POPUP - Add VPA */}
      {isAddvpa && !isValidateConfirm && (
        <div className="modal fade show mymodal">
          <div className="modal-dialog modal-lg">
            <div className="modal-content border11">
              <div className="modal-header modalhead">
                <h5 className="modal-title">Add VPA</h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setIsAddvpa(false);
                    setIsValidate(0);
                  }}
                >
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <input
                  className="form-control vpaAddress"
                  value={VpaId}
                  readOnly={isValidate === 1}
                  onChange={(e) => setVpaId(e.target.value)}
                  placeholder="Enter VPA address"
                />

                <div className="vpa-action-buttons">
                  <div className="button-row">
                    <button
                      disabled={isValidate === 1 || !VpaId || VpaId.trim() === ''}
                      className={`vpa-btn ${isValidate === 0 && VpaId && VpaId.trim() !== '' ? 'active-btn' : 'inactive-btn'}`}
                      onClick={() => {
                        if (VpaId && VpaId.trim() !== '') {
                          setIsValidateConfirm(true);
                        }
                      }}
                    >
                      Validate
                    </button>
                    <button
                      disabled={isValidate === 0 || (!canResend && reg_vpa === VpaId)}
                      className={`vpa-btn ${isValidate === 1 ? 'active-btn' : 'inactive-btn'}`}
                      onClick={() => {
                        // Directly register VPA without internet confirmation
                        registerHH();
                      }}
                    >
                      Register
                      {!canResend &&
                        reg_vpa === VpaId &&
                        time.minutes !== 0 &&
                        time.seconds !== 0 && (
                          <span className="timer">
                            ({time.minutes}:{time.seconds})
                          </span>
                        )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MAIN UI */}
      <section className="main-sec">
        <div className="container fix-width">
          <div className="utr_navbar mb-2">
            <button
              className="button back_button"
              onClick={() => history.goBack()}
            >
              <img src={require("../assets/images/back.png")} alt="" />
            </button>

            <h3>UPI Autopay</h3>

            <button className="button" onClick={() => logout(otherScreen)}>
              <img src={require("../assets/images/power-off.png")} alt="" />
            </button>
          </div>

          <div className="search-holder mt-4">
            <div className="search-row">
              <div className="search-input-container">
                <input
                  className="form-control search-box"
                  placeholder="Enter Household Number"
                  value={searchhhno}
                  onChange={(e) => setSearchHHNo(e.target.value)}
                />
              </div>
              <button className="search-btn-mobile" onClick={gethhdetail}>
                <i className="fa fa-search"></i>
              </button>
              <div className="search-btn-container">
                <button className="btn search-btn" onClick={gethhdetail}>
                  <i className="fa fa-search"></i> Search
                </button>
              </div>
            </div>

            <div className="upi-card-holder">
              {hhdata.length !== 0 && (
                <section className="sub-card-container">
                  <div className="head-card-container">
                    <div className="head-content">
                      <div className="head-left">
                        <h1 className="hh-name">HH Name: {hhdata.household_name}</h1>
                        <div className="hh-id-section">
                          <p className="hh-id">HH ID: {hhdata.household_number}</p>
                        </div>
                      </div>
                      <div className="branch-right">
                        <span className="branch-tag">{hhdata.branch_name}</span>
                      </div>
                    </div>
                  </div>

                  {hhvpadata &&
                    hhvpadata.map((item, index) => (
                      <div key={index} className="member-card">
                        <div className="member-header">
                          <div className="member-info">
                            <div className="member-avatar">
                              <img src={img} alt="Member" />
                            </div>
                            <div className="member-details">
                              <span className="member-name">{item.family_member_name}</span>
                              {item.family_relation_name && (
                                <p className="member-relation">{item.family_relation_name}</p>
                              )}
                            </div>
                          </div>

                          <button
                            className="add-vpa-btn"
                            onClick={() => {
                              setVpaId("");
                              setIsAddvpa(true);
                              setHHId(hhdata.household_id);
                              setFamilyMemberId(item.family_member_id);
                              setIsValidate(0);
                            }}
                          >
                            <i className="fa fa-plus"></i> VPA
                          </button>
                        </div>

                        {item.vpa_details && item.vpa_details.map((vpadata, vIndex) => (
                          <div key={vIndex} className="vpa-item">
                            <div className="vpa-row">
                              <div className="vpa-selection">
                                <input
                                  type="radio"
                                  className="vpa-radio"
                                  disabled={
                                    vpadata.autopay_status_type_flag == null ||
                                    vpadata.autopay_status_type_flag === ""
                                  }
                                  checked={vpadata.default_flag === 1}
                                  onChange={() => {
                                    setVpaId(vpadata.vpa_address);
                                    setHHId(hhdata.household_id);
                                    setIsSetDefault(true);
                                  }}
                                />
                                <span className="vpa-address">{vpadata.vpa_address}</span>
                              </div>
                              
                              <div className="vpa-status">
                                {vpadata.status_type_description && vpadata.status_type_description !== "" && (
                                  <span className={`status-text ${
                                    vpadata.autopay_status_type_flag === "J" ? "status-error" : "status-success"
                                  }`}>
                                    {vpadata.autopay_status_type_flag === "R" && (
                                      <img src={verified} alt="Verified" className="verified-icon" />
                                    )}
                                    {vpadata.status_type_description}
                                  </span>
                                )}
                              </div>

                              <div className="vpa-actions">
                                {vpadata.status !== "X" &&
                                  vpadata.autopay_status_type_flag !== "R" && (
                                    <button
                                      className="action-btn check-btn"
                                      onClick={() => {
                                        // OLD VERSION BEHAVIOR: Opens Add VPA modal with pre-filled VPA
                                        setVpaId(vpadata.vpa_address);
                                        setHHId(hhdata.household_id);
                                        setFamilyMemberId(item.family_member_id);
                                        setIsAddvpa(true);
                                        setIsValidate(1); // Set to 1 to disable Validate button
                                      }}
                                    >
                                      <img src={check} alt="Check" />
                                    </button>
                                  )}

                                {vpadata.autopay_status_type_flag !== "R" &&
                                  vpadata.status !== "X" && (
                                    <button
                                      className="action-btn delete-btn"
                                      onClick={() => {
                                        setIsDelete(true);
                                        setVpaId(vpadata.vpa_address);
                                        setRemark("");
                                        setRemarkErr("");
                                      }}
                                    >
                                      <img src={del_red} alt="Delete" />
                                    </button>
                                  )}

                                {vpadata.autopay_status_type_flag !== "R" &&
                                  vpadata.status !== "X" && (
                                    <button
                                      className="action-btn refresh-btn"
                                      onClick={() => {
                                        // Directly call API without confirmation - OLD VERSION BEHAVIOR
                                        UpdateVPAstatus(vpadata.vpa_address);
                                      }}
                                    >
                                      <img src={load_blue} alt="Refresh" />
                                    </button>
                                  )}

                                <button
                                  className="action-btn history-btn"
                                  onClick={() => {
                                    gethistory(vpadata.vpa_address);
                                  }}
                                >
                                  <img
                                    src={require("../assets/images/right-arrow.png")}
                                    alt="History"
                                  />
                                </button>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                </section>
              )}
            </div>
          </div>
        </div>
      </section>

      <ChatSupportBtn history={history} />
    </>
  );
}